export default __webpack_public_path__ + "static/media/ot_quiz_bg.a0485dd1.png";